import React from "react";
import {
  Box,
  Checkbox,
  Text,
  Stack,
  Input,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/core";
import { GoPlus } from "react-icons/go";
import { MdEuroSymbol } from "react-icons/md";

function CheckoutFormMockup({ activeOption }) {
  return (
    <Stack
      p="24px"
      color="primary.transparent-600"
      minH="200px"
      bg="#fafafa"
      textAlign="left"
      borderRadius="5px"
      w="90%"
      maxW="400px"
      m="auto"
    >
      <Stack spacing={0}>
        <Text fontSize="sm" textTransform="uppercase">Order details</Text>
        <Stack isInline fontSize="10px" spacing={2} borderRadius="10px">
          <Input
            focusBorderColor="none"
            name="description"
            placeholder="Pizza with pinapple x 3"
            size="sm"
            isReadOnly
          />
          <InputGroup size="sm">
            <InputLeftElement
              color="gray.300"
              fontSize="1.2em"
              children={<Box as={MdEuroSymbol} color="primary.400" />}
            />
            <Input
              focusBorderColor="none"
              size="sm"
              placeholder="49.99"
              name="amount"
              isReadOnly
            />
          </InputGroup>
          <Box as={GoPlus} size="32px" />
        </Stack>
        <Text my="12px" fontSize="sm" color="primary.500">Payment total request:
          <Box as="span" fontWeight="bold"> 49.99 € </Box>
        </Text>
        <Box bg="warning.100" my="16px" p="12px">
          <Checkbox
            borderColor="primary.400"
            size="sm"
            variantColor="warning"
            name="sms"
            defaultIsChecked
          >
            <Text fontWeight="bold">Send as SMS</Text>

            <Text fontSize="xs">
              Automatically send the payment request link as SMS to Haja (+33 6
              17 57 01 03)
            </Text>
          </Checkbox>
        </Box>

        
      </Stack>
      <Stack textTransform="uppercase" isInline justifyContent="flex-end" fontWeight="bold" fontSize="sm">
        <Box
          color="white"
          py="4px"
          w="50%"
          borderRadius="3px"
          textAlign="center"
          bg="success.400"
        >
          Create Link
        </Box>
        <Box
          color="primary.400"
          py="4px"
          w="35%"
          borderRadius="3px"
          textAlign="center"
          bg="primary.100"
        >
          Cancel
        </Box>
        </Stack>    </Stack>
  );
}

export default CheckoutFormMockup;
